module.exports = __webpack_public_path__ + "img/bm.7d91827.svg";